import { Field, Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { integerRegex } from "../../../../../constants/constants";
import LoaderButton from "../../../../../shared-components/button/loader-button";
import FormikFormInputForRegexCheck from "../../../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import Label from "../../../../../shared-components/label/label";
import { timeInitialState } from "../../../../../core/initialState/master-settings-state";
import { useStore } from "../../../../../contexts/store-provider";
import FormikFormInput from "../../../../../shared-components/FormikFormHandlers/FormikFormInput";
import * as Yup from "yup";
import { toHalfWidth } from "../../../../../helpers/validate-helper";
interface IProps {
  id: number;
  initialValues: any;
  submitHandler: (data: any) => void;
  addUpdateInProgress: boolean;
  actionSuccess: boolean;
  onCancelEdit: () => void;
}

const validationSchema = Yup.object().shape({
  Time: Yup.number()
    .typeError("time_value_must_be_a_number")
    .min(0, "time_value_must_be_at_least_1")
    .max(300, "time_value_must_not_exceed_300")
    .test(
      "is-multiple-of-5",
      "time_value_must_be_multiple_of_5",
      (value) => value === undefined || value % 5 === 0
    )
    .required("field_required"),
  Description: Yup.string().max(300, "max_300_characters"),
});

const AddTimeSettingsForm: React.FC<IProps> = (props: IProps) => {
  const {
    submitHandler,
    addUpdateInProgress,
    actionSuccess,
    initialValues,
    id,
    onCancelEdit,
  } = props;
  const { masterManagementStore } = useStore();
  const { addUpdateTimeSettingState } = masterManagementStore;
  let resetPresForm = () => {};
  const [initialValue, setInitialValue] = useState<any>({
    ...initialValues,
  });
  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  /**
   * This functional component stores the reset form function in the resetPresentForm variable
   */
  const ResettingForm = () => {
    const { resetForm } = useFormikContext();
    resetPresForm = resetForm;
    return null;
  };

  useEffect(() => {
    if (addUpdateTimeSettingState) {
      setInitialValue({ ...timeInitialState });
      resetPresForm();
    }
  }, [addUpdateTimeSettingState]);

  useEffect(() => {
    if (actionSuccess) {
      resetPresForm();
      setInitialValue({ ...timeInitialState });
    }
  }, [actionSuccess]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={async (values: any) => {
          submitHandler(
            id > 0
              ? {
                  ...values,
                  Id: id,
                  Time: toHalfWidth(values.Time),
                  IsTimeUpdated:
                    toHalfWidth(values.Time) !==
                    toHalfWidth(initialValues.Time),
                }
              : {
                  Description: values.Description,
                  Time: toHalfWidth(values.Time),
                }
          );
        }}
      >
        {({ values, resetForm }) => (
          <>
            <Form className="setting-form" noValidate>
              <FormObserver />
              <Row className="position-relative">
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label className="form-label" required={true} label="time" />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Time"
                    placeholder="enter_time_value"
                    regex={integerRegex}
                    as={FormikFormInputForRegexCheck}
                  />
                </Col>
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={false}
                    label="description"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Description"
                    placeholder="description"
                    as={FormikFormInput}
                    validcharacter={[
                      "・",
                      "／",
                      "－",
                      "～",
                      "＋",
                      "（",
                      "）",
                      "［",
                      "］",
                      "※",
                      "：",
                      "★",
                      "☆",
                      "◎",
                      "○",
                      "●",
                      "◆",
                      "◇",
                      "■",
                      "□",
                      "→",
                      "⇒",
                      "♪",
                      "(",
                      ")",
                      "【",
                      "】",
                      "￥",
                      '"',
                      "＜",
                      "＞",
                      "！",
                      "？",
                      "↓",
                      "↑",
                      "←",
                      "．",
                      '"',
                      "゛",
                      "'",
                      "'",
                      '"',
                      '"',
                      "、",
                      "。",
                      "《",
                      "》",
                      "+",
                      "-",
                      "[",
                      "]",
                      "|",
                      "*",
                      "&",
                      "/",
                      ".",
                      "!",
                      "@",
                      "#",
                      "$",
                      "%",
                      "^",
                      "_",
                      "`",
                      "{",
                      "}",
                      "?",
                      ";",
                      ":",
                      ",",
                      "=",
                      "~",
                      "<",
                      ">",
                    ]}
                  />
                  <p className="small text-muted text-end mt-1">{`${
                    values.Description ? values.Description.length : 0
                  }/300`}</p>
                </Col>
                <Col sm={2} md={2} lg={2} xl={2}>
                  <LoaderButton
                    type="submit"
                    className="label-top-margin"
                    isLoading={addUpdateInProgress}
                    disabled={addUpdateInProgress}
                    text={id > 0 ? "button_update" : "add"}
                  />

                  {id > 0 && (
                    <LoaderButton
                      type="button"
                      className="label-top-margin ms-2"
                      variant="danger"
                      onClick={() => {
                        onCancelEdit();
                        setInitialValue({ ...timeInitialState });
                        resetPresForm();
                        resetForm({ values: timeInitialState });
                      }}
                      isLoading={false}
                      disabled={addUpdateInProgress}
                      text="button_cancel"
                    />
                  )}
                </Col>
              </Row>

              <ResettingForm />
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default observer(AddTimeSettingsForm);
